export class LocationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getNonUSCountries() {
    return this.#http.get('/locations/non-us-countries');
  }

  async getCounties() {
    return this.#http.get('/locations/counties');
  }
}
